import styles from './SelectionPage.module.css'
import SelectionForm from '../../components/SelectionForm/SelectionForm'
import ServiceKinds from '../../components/ServiceKinds/ServiceKinds'
import SelectionAchievements from '../../components/SelectionAchievements/SelectionAchievements'
import SelectionSteps from '../../components/SelectionSteps/SelectionSteps'
import AdditionalSelectionQuestions from '../../components/AdditionalSelectionQuestionsSection/AdditionalSelectionQuestionsSection'
import ReviewsSection from '../../components/ReviewsSection/ReviewsSection'

export default function SelectionPage() {
  return (
    <div className={styles.page}>
      <section className={styles.topSection}>
        <SelectionForm />
        <SelectionAchievements />
        <ServiceKinds />
      </section>
      <section className={styles.midSection}>
        <SelectionSteps />
      </section>
      <section className={styles.midSection}>
        <ReviewsSection />
      </section>
      <section className={styles.midSection}>
        <AdditionalSelectionQuestions />
      </section>
    </div>
  )
}